// Order the steps: the taps, kept pure so they are tested on their own. Cards stay where they are; each tap gives the
// next number to the card tapped, and tapping the card that took the last number takes it back. A card that already
// has an earlier number is left alone, so a stray tap never unpicks a whole run.
export type OrderTap = 'add' | 'undo' | 'none';

export function tapStep(seq: readonly string[], id: string): { seq: string[]; action: OrderTap } {
  const at = seq.indexOf(id);
  if (at < 0) return { seq: [...seq, id], action: 'add' };
  if (at === seq.length - 1) return { seq: seq.slice(0, -1), action: 'undo' };
  return { seq: [...seq], action: 'none' };
}

export const undoStep = (seq: readonly string[]): string[] => seq.slice(0, -1);

/** A card's number in the player's order, from 1; undefined until it has one. */
export function positionOf(seq: readonly string[], id: string): number | undefined {
  const i = seq.indexOf(id);
  return i < 0 ? undefined : i + 1;
}

/** True once every step has a number. */
export const isComplete = (seq: readonly string[], ids: readonly string[]): boolean =>
  ids.length > 0 && seq.length === ids.length && ids.every((id) => seq.includes(id));
